import { z } from 'zod';

export const AddressSuggestionZod = z.object({
    street_line: z.string().optional(),
    secondary: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    zipcode: z.string().optional(),
});
export type AddressSuggestion = z.infer<typeof AddressSuggestionZod>;
